import './works.css';
import image from '../../assets/flyer.jpeg'
import Card from '../../components/Card'
import data from './data'

const Works = () => {
  return (
   <section id="HowItWorks">
     <h2>How Our 360 Photo booth Works at your Event</h2><br />
     <div className="container about__container">

    <p>
  Once we have your request booked for the 360 video booth hire, here is how it works:  <br /><br />
   1. Our tech-support set and powers the 360 video at your event location.  <br /><br />
   2. Your guest up to 2 or 7 depending your choice of device, steps onto the 360 video booth platform. <br /><br />
   3. Our tech-support starts the recording and the arm rotates and spins around.<br /><br />
   4. The video is recorded for 10 to 30 seconds as the arm spins around.<br /><br />
   5. Our tech-support stops the recording and the arm stop spinning.<br /><br />
   6. Your guest step off the 360 video booth platform <br /><br />
   7. Our 360 video software immediate the video in a few minutes<br /><br />
   8. Video is available and the guest are able to share the video on their social platform.<br /><br />

    </p>




           

      
     </div>
    <div className='hire'>
    <div className='underline'></div>
    <a href="#footer" className='btn primary'>Hire Now</a>
      <div className='underline'></div>
    </div>
   </section>
  )
}

export default Works